"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var urlUtil = {
  generateUrlWithQuery: function generateUrlWithQuery(baseUrl, object) {
    // remove null of undefined atribute
    var obj = _lodash.default.omitBy(object, _lodash.default.isNil);
    var parts = _lodash.default.map(obj, function (value, key) {
      return "".concat(key, "=").concat(value);
    });
    return "".concat(baseUrl, "?").concat(parts.join('&'));
  },
  getPMTUrl: function getPMTUrl(key) {
    if (window.PMT_URLS && window.PMT_URLS.get) {
      return window.PMT_URLS.get(key);
    }
    return "Please make sure you have configured the link (".concat(key, ") on core UI");
  }
};
var _default = urlUtil;
exports.default = _default;